// extracted by mini-css-extract-plugin
module.exports = {"settingsBreadcrumbs":"SettingBreadCrumbs_settingsBreadcrumbs__3vIWi","link":"SettingBreadCrumbs_link__sLDio"};